export type ExterniKontaktTyp = 'STAROSTA' | 'RODINA' | 'JINY';

export const KONTAKT_TYP_LABELS: Record<ExterniKontaktTyp, string> = {
    STAROSTA: 'Starosta',
    RODINA: 'Rodina člena',
    JINY: 'Jiný',
};

export interface ExterniKontakt {
    id: number;
    typ: ExterniKontaktTyp;
    jmeno: string;
    email?: string;
    telefon?: string;
    clenId?: number;
    clenJmeno?: string;
    posilatSouhrn: boolean;
    aktivni: boolean;
    createdAt?: string;
    updatedAt?: string;
}

export interface ExterniKontaktRequest {
    typ: ExterniKontaktTyp;
    jmeno: string;
    email: string;
    telefon?: string;
    clenId?: number | null;
    posilatSouhrn: boolean;
    aktivni: boolean;
}

export interface RodinnyPinStatus {
    aktivni: boolean;
    createdAt?: string;
}
